import * as classnames from 'classnames'
import * as React from 'react'
import * as styles from './searchBannersWithIconsBlock.module.css'

import { customerMarketShopfrontApi } from '@envato/foundation-types'

import { reportCategoryPageClick } from '../../../../common/analytics/categoryPageAnalytics'
import SearchLinkContainer from '../../../containers/searchLinkContainer'
import ArrowIcon from '../../icons/thinArrowRight'
import { BannerIcons } from '../../icons/categoryPage'
import { ICategoryPageBlockComponent } from '../../../../typings/pageBlocks'

interface IProps extends ICategoryPageBlockComponent {
  data: customerMarketShopfrontApi.categoryPage.ISearchBannerWithIconBlockData[]
}

const SearchBannersWithIconsBlock = ({ data }: IProps) => {
  const renderBanner = (
    banner: customerMarketShopfrontApi.categoryPage.ISearchBannerWithIconBlockData,
    index: number
  ) => {
    const { icon, title, urlSearchParams } = banner
    const bannerStyles = classnames(styles.banner, {
      [styles.dark]: !(index % 2)
    })

    return (
      <SearchLinkContainer
        locationParams={urlSearchParams}
        className={bannerStyles}
        key={index}
        onClick={reportCategoryPageClick(title)}
      >
        <div className={styles.icon}>{BannerIcons[icon]}</div>
        <div className={styles.detail}>
          <h3 className={styles.title}>{title}</h3>
          <span className={styles.cta}>
            <span className={styles.ctaText}>Browse now</span>
            <ArrowIcon />
          </span>
        </div>
      </SearchLinkContainer>
    )
  }

  return <div className={styles.root}>{data.map(renderBanner)}</div>
}

export default SearchBannersWithIconsBlock
